var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-box"},[_c('div',{staticClass:"content"},_vm._l((_vm.imgs),function(i,j){return _c('img',{key:j,attrs:{"src":i}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }